module.exports = __webpack_public_path__ + "static/resource-placeholder-e741b42d4ba7eee6c5c4b8aa3a8afd8b.png";